import Vue from 'vue';
import Router from 'vue-router';
import Calculette from '@/components/calculette/Calculette.vue';
import CalculetteEtape2 from '@/components/calculette/Etape2.vue';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/calculette/etape1',
      name: 'routeCalculetteEtape1',
      title: 'Calculette',
      meta: { layout: 'default' },
      component: Calculette,
    },
    {
      path: '/calculette/etape2',
      name: 'routeCalculetteEtape2',
      props: true,
      meta: { layout: 'default' },
      component: CalculetteEtape2,
    },
    {
      path: '/',
      redirect: '/calculette/etape1',
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
